import type { HomeEconomy } from "@/home/economy";
import type { SkillBarState } from "@/character/skills/types";
import { SKILL_LIBRARY_MAX } from "@/character/skills/constants";

export function petSkillLibrarySlotsUnlocked(economy: HomeEconomy): number {
  return Math.min(SKILL_LIBRARY_MAX, Math.max(1, Math.floor(economy.petSkillLibrarySlotsUnlocked)));
}

export function canAddPetSkillToLibrary(bar: SkillBarState, economy: HomeEconomy): boolean {
  return bar.library.length < petSkillLibrarySlotsUnlocked(economy);
}

export function consumePetSkillCreateCard(economy: HomeEconomy): HomeEconomy | null {
  if (economy.petSkillCreateCards < 1) return null;
  return { ...economy, petSkillCreateCards: economy.petSkillCreateCards - 1 };
}
